
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DataTableHeader } from 'vuetify';
import WebsiteMigrationsRepositoryInterface, { WebsiteMigration } from '@/services/WebsiteMigrations/interfaces';
import WebsiteRepositoryInterface from '@/services/Website/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'websiteMigrationsRepository',
    'websiteRepository',
  ],
})
export default class WebsiteMigrationsList extends Vue {
  public loading: boolean = true;

  public options: { page: number, itemsPerPage: number } = {
    page: 1,
    itemsPerPage: 10,
  };

  public totalMigrationsCount = 10;

  public migrationSearch: string = '';

  public migrations: WebsiteMigration[] = [];

  public websitesDomainMap: { [key: number]: string } = {};

  public headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Source Website', value: 'sourceWebsiteId' },
    { text: 'Target Website', value: 'targetWebsiteId' },
    { text: 'Type', value: 'type' },
    { text: 'Status', value: 'status' },
  ];

  public websiteMigrationsRepository!: WebsiteMigrationsRepositoryInterface;
  public websiteRepository!: WebsiteRepositoryInterface;

  public async created(): Promise<void> {
    await this.loadMigrations();
  }

  public async loadMigrations(): Promise<void> {
    try {
      const search = this.migrationSearch.toLowerCase();

      let status: string = '';
      if (['done', 'pending', 'error'].includes(search)) {
        status = search;
      }

      let type: string = '';
      if (['main to main', 'sub to sub', 'rename'].includes(search)) {
        type = search;

        if (search !== 'rename') {
          type = `migrate-${search.split(' ').join('-')}`;
        }
      }

      const response = await this.websiteMigrationsRepository.getAllMigrations(
        this.options.page,
        this.options.itemsPerPage,
        undefined,
        undefined,
        type,
        status,
      );


      if (response.totalItems > 0) {
        const sourceWebsitesIds: number[] = [];
        const targetWebsitesIds: number[] = [];

        response.migrations.forEach((m) => {
          if (!sourceWebsitesIds.includes(m.sourceWebsiteId)) {
            sourceWebsitesIds.push(m.sourceWebsiteId);
          }

          if (!targetWebsitesIds.includes(m.targetWebsiteId)) {
            targetWebsitesIds.push(m.targetWebsiteId);
          }
        });

        const websites = await Promise.all([
          ...(await this.websiteRepository.getWebsitesByIds(sourceWebsitesIds)),
          ...(await this.websiteRepository.getWebsitesByIds(targetWebsitesIds)),
        ]);

        websites.forEach((website) => {
          this.websitesDomainMap[website.id] = website.domain;
        });
      }

      this.totalMigrationsCount = response.totalItems;
      this.migrations = response.migrations;

    } catch (error) {
      this.$errorDialog.show(error.response?.data?.error || error.message);
    } finally {
      this.loading = false;
    }
  }

  public async viewMigration(migration: WebsiteMigration): Promise<void> {
    await this.$router.push({
      name: 'view_website_migration',
      params: { id: migration.id.toString() },
    });
  }

  public getTypeString(type: string): string {
    return type
      .replaceAll('migrate', '')
      .replaceAll('-', ' ')
      .toUpperCase();
  }
}
